import { createRouteFor } from "@components-common/routes";
import { dataSection, dataSectionBase} from "../routes.section";
const basePath = dataSectionBase;

const routesForBuildingParameter = createRouteFor<typeof dataSection,"building_parameters">(dataSection,"building_parameters");

export const buildingParametersRoutes = {
  index: routesForBuildingParameter("index",{basePath}),
  create: routesForBuildingParameter("create",{basePath}),
  details: routesForBuildingParameter("details",{basePath})
}

export type BuildingParametersRoutesIds = typeof buildingParametersRoutes[keyof typeof buildingParametersRoutes]["id"];
